export default defineNuxtPlugin(() => {
  return {
    provide: {
      numberOnly: (evt) => {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          (charCode > 1775 && charCode < 1786) ||
          (charCode > 1631 && charCode < 1642) ||
          (charCode > 47 && charCode < 58)
        ) {
          return true;
        } else {
          evt.preventDefault();
        }
      },

      validateNationalCode: (code) => {
        if (code && code != "0000000000") {
          if (!/^\d{10}$/.test(code)) {
            return false;
          } else {
            const check = +code[9];
            const sum =
              Array(9)
                .fill()
                .map((_, i) => +code[i] * (10 - i))
                .reduce((x, y) => x + y) % 11;
            return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
          }
        }
      },

      validateMobile: (mobile) => {
        if (mobile) {
          if (mobile[0] == 9 && mobile[1] == 8) {
            if (mobile.length == 12) {
              return true;
            } else {
              return false;
            }
          } else if (mobile[0] == 0) {
            if (mobile.length == 11) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      },

      validateFaChar: (text) => {
        if (text) {
          let newText = text.trim();
          if (/^[\u0600-\u06FF\s]+$/.test(newText)) {
            return true;
          } else {
            return false;
          }
        }
      },

      validateEmail: (email) => {
        if (email) {
          if(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]+/.test(email)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true
        }
      },
    }
  }
})